import ObjectView from '@scene/views/object-view';
import WoodConnectionObject from './wood-connection.object';

export default {
  name: 'Wood Connection',
  mode: ObjectView.mode.MODE_2D,
  type: WoodConnectionObject.types.STRAIGHT,
  dimensions: {
    width: 100,
    height: 300,
    depth: 50
  },
  position: {
    x: 0,
    y: 0,
    z: 0
  },
  materials: {
    woodColor: 0xdeb887,
    secondaryWoodColor: 0xc4a68b,
    metalColor: 0x808080,
    nailColor: 0x000000,
    properties: {
      metal: {
        roughness: 0.7,
        metalness: 0.3
      }
    }
  },
  spacing: {
    horizontal: 15,
    vertical: {
      s: 40,
      c: 40
    }
  },
  formations: {
    notSet: 'NOT_SET',
    triangle: 'TRIANGLE',
    filledSquare: 'FILLED_SQUARE',
    emptySquare: 'EMPTY_SQUARE',
    circle: 'CIRCLE'
  },
  generators: {
    custom: 'custom',
    grid: 'grid'
  },
  nail: {
    radius: 1
  },
  plate: {
    a: 290,
    b: 50,
    c: 40,
    tfixA: 3,
    tfixB: 8
  }
};



// WEBPACK FOOTER //
// ./src/object-view/generators/wood-connection/defaultOptions.js